// extracted by mini-css-extract-plugin
export var fullHeightState = "_4y-7";
export var headerCell = "_4y-1";
export var loadingStateCell = "_4y-4";
export var rowWrapper = "_4y-3";
export var standaloneTable = "_4y-8";
export var standaloneTableWithBodyFill = "_4y-9";
export var stateCell = "_4y-5";
export var table = "_4y-0";
export var tableBodyFiller = "_4y-6";
export var white = "_4y-2";